import {
  Component
} from '@angular/core';


export class SkyToolbarSectionComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-toolbar-section',
  styles: [`.sky-toolbar-section {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  position: relative;
  min-height: 49px;
}
`],
  template: `<div class="sky-toolbar-section">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
